module.exports = __webpack_public_path__ + "static/media/overlay-blue.4399bb17.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tags/overlay-blue.svg
// module id = 563
// module chunks = 0